import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { SeFeTab } from 'se-fe-tabs'

@Component({
  selector: 'app-open-registration',
  templateUrl: './open-registration.component.html',
  standalone: false,
})
export class OpenRegistrationComponent {
  public tabs: SeFeTab[]
  private readonly completedRegistrationsPath = '/user/open-registration/completed'

  constructor(
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {
    this.tabs = [
      { routerLink: '/user/open-registration/open', text: this.translate.instant('REGISTRATIONS.open_registrations') },
      { routerLink: this.completedRegistrationsPath, text: this.translate.instant('REGISTRATIONS.completed_registrations') },
    ]
  }

  public handleTabsClick(event: MouseEvent): void {
    const clickedTab = this.clickedTabElement(event)
    const href = clickedTab?.getAttribute('href') || ''

    if (href.includes(this.completedRegistrationsPath)) {
      this.analyticsService.seEvent('CompletedRegistrations')
    }
  }

  private clickedTabElement(event: MouseEvent): Element | null {
    const path = event.composedPath?.() || []
    const pathTab = path.find((target) => (
      target instanceof Element && target.matches('a[role="tab"]')
    ))

    if (pathTab instanceof Element) return pathTab

    let target = event.target
    if (target instanceof Text) {
      target = target.parentElement
    }

    return target instanceof Element ? target.closest('a[role="tab"]') : null
  }
}
